module.exports = __webpack_public_path__ + "img/Logo1.53648760.png";